import { QuestionType } from "../../../types/Enum";
import { QuestionTypeInt } from "../../../types/Interface";


export default function genQuestionType(QuestionTypes: QuestionTypeInt) {
  const questionTypes = Object.entries(QuestionTypes).filter(t => t[1]).map(t => t[0]);
  return QuestionType[questionTypes[Math.floor(Math.random() * questionTypes.length)]];
}